<template>
  <svg :class="className" aria-hidden="true">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true }, // SVG文件名
    className: { type: String, default: '' } // 自定义类名
  }
}
</script>